import React from "react";

function getPreviousMonthWithYear(): string {
    const date = new Date();
    date.setMonth(date.getMonth() - 1); // go to previous month

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    return `${month} ${year}`;
}

const MonthlyComplaints: React.FC = () => {
    const complaintData = {
        beginning: 0,
        received: 0,
        resolved: 0,
        pending: 0,
        lastUpdated: getPreviousMonthWithYear(),
    };

    return (
        <div className="flex flex-col items-center text-white rounded-lg shadow-lg">
            <h2 className="text-lg font-semibold">
                No. of Complaints received from Investors
            </h2>
            <p className="text-sm">For the month of <span className="font-bold">{complaintData.lastUpdated}</span></p>

            <div className="mt-4 w-full overflow-hidden">
                <div className="w-full overflow-hidden">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full text-sm text-white">
                            <thead>
                                <tr className="text-left">
                                    <th className="p-2 border border-[#57c0af]">Received From</th>
                                    <th className="p-2 border border-[#57c0af] hidden sm:table-cell">Pending Last Month</th>
                                    <th className="p-2 border border-[#57c0af]">Received</th>
                                    <th className="p-2 border border-[#57c0af] hidden sm:table-cell">Resolved</th>
                                    <th className="p-2 border border-[#57c0af]">Total Pending</th>
                                    <th className="p-2 border border-[#57c0af] hidden md:table-cell">Pending &gt; 3 Months</th>
                                    <th className="p-2 border border-[#57c0af] hidden md:table-cell">Avg Resolution Time (Days)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[
                                    { source: "Directly from Investors", pending: 0, received: 0, resolved: "NA", totalPending: 0, pending3Months: 0, resolutionTime: 0 },
                                    { source: "SEBI (SCORES)", pending: 0, received: 0, resolved: "NA", totalPending: 0, pending3Months: 0, resolutionTime: 0 },
                                    { source: "Other", pending: 0, received: 0, resolved: "NA", totalPending: 0, pending3Months: 0, resolutionTime: 0 },
                                    { source: "Sources (if any)", pending: 0, received: 0, resolved: "NA", totalPending: 0, pending3Months: 0, resolutionTime: 0 },
                                ].map((item, index) => (
                                    <tr key={index} className="border-t border-[#57c0af]">
                                        <td className="p-2 border border-[#57c0af]">{item.source}</td>
                                        <td className="p-2 border border-[#57c0af] hidden sm:table-cell text-center">{item.pending}</td>
                                        <td className="p-2 border border-[#57c0af] text-center">{item.received}</td>
                                        <td className="p-2 border border-[#57c0af] hidden sm:table-cell text-center">{item.resolved}</td>
                                        <td className="p-2 border border-[#57c0af] text-center">{item.totalPending}</td>
                                        <td className="p-2 border border-[#57c0af] hidden md:table-cell text-center">{item.pending3Months}</td>
                                        <td className="p-2 border border-[#57c0af] hidden md:table-cell text-center">{item.resolutionTime}</td>
                                    </tr>
                                ))}
                                <tr className="font-bold">
                                    <td className="p-2 border border-[#57c0af]">Grand Total</td>
                                    <td className="p-2 border border-[#57c0af] hidden sm:table-cell text-center">0</td>
                                    <td className="p-2 border border-[#57c0af] text-center">0</td>
                                    <td className="p-2 border border-[#57c0af] hidden sm:table-cell text-center">NA</td>
                                    <td className="p-2 border border-[#57c0af] text-center">0</td>
                                    <td className="p-2 border border-[#57c0af] hidden md:table-cell text-center">0</td>
                                    <td className="p-2 border border-[#57c0af] hidden md:table-cell text-center">0</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="mt-4 text-sm text-gray-400 text-center">
                <p>* Inclusive of complaints of previous months resolved in the current month.</p>
                <p># Inclusive of complaints pending as on the last day of the month.</p>
                <p>
                    ^ Average Resolution time is the sum total of time taken to resolve each complaint in days,
                    in the current month divided by total number of complaints resolved in the current month.
                </p>
            </div>
        </div>
    );
};

export default MonthlyComplaints;
